import React from "react";
import Routes from "./routes/routes";
import "./styles/styles.css";

function App() {
  return <Routes />;
}

export default App;
